import AuthenticationService from '@/services/AuthenticationService';
import ActionService from "@/services/ActionService";

export default {
  data() {
    return {
      SurveyRevisionStatus: ActionService.SurveyRevisionStatus
    };
  },

  computed: {
    getRevisionStatusOptions() {
      return [
        { value: this.SurveyRevisionStatus.New, text: this.getRevisionStatusText(this.SurveyRevisionStatus.New) },
        { value: this.SurveyRevisionStatus.Approved, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Approved) },
        { value: this.SurveyRevisionStatus.Dismissed, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Dismissed) },
        { value: this.SurveyRevisionStatus.AcceptedInProgress, text: this.getRevisionStatusText(this.SurveyRevisionStatus.AcceptedInProgress) },
        { value: this.SurveyRevisionStatus.Solved, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Solved) },
        { value: this.SurveyRevisionStatus.Revised, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Revised) },
        { value: this.SurveyRevisionStatus.RevisedApproved, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedApproved) },
        { value: this.SurveyRevisionStatus.RevisedDismissed, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedDismissed) },
        { value: this.SurveyRevisionStatus.Done, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Done) },
      ];
    },

    notificationSettingsRoute() {
      return this.$router.currentRoute.path.startsWith("/external") ?
        {name: 'ExternalNotificationSettings'} :
        {name: 'Notification settings'};
    }
  },

  methods: {
    userHasActionRevisePermission: function() {
      return AuthenticationService.localUserProfile.Permissions.includes('ActionsRevise');
    },

    getRevisionCreatedText(surveyRevision) {
      let at = surveyRevision.CreatedAt ? this.$options.filters.msm_timefromnow(surveyRevision.CreatedAt) : null;
      let by = surveyRevision.CreatedBy ?
        `${surveyRevision.CreatedBy.FirstName} ${surveyRevision.CreatedBy.LastName}` +
        (surveyRevision.CreatedBy.Email ? ` (${surveyRevision.CreatedBy.Email})` : '')
        : null;

      return this.$t('Webportal.Created') + ' ' + at +
        (by ? ' ' + this.$t('Webportal.By', { by }) : '');
    },

    getRevisionLastUpdatedText(surveyRevision) {
      let at = this.$options.filters.msm_timefromnow(surveyRevision.ModifiedAt ? surveyRevision.ModifiedAt : surveyRevision.CreatedAt);
      let by = surveyRevision.ModifiedAt && surveyRevision.ModifiedBy ?
        `${surveyRevision.ModifiedBy.FirstName} ${surveyRevision.ModifiedBy.LastName}` :
        !surveyRevision.ModifiedAt && surveyRevision.CreatedBy ?
          `${surveyRevision.CreatedBy.FirstName} ${surveyRevision.CreatedBy.LastName}` : null;

      return this.$t('Webportal.LastUpdated', { at }) +
        (by ? ' ' + this.$t('Webportal.By', { by }) : '');
    },

    getRevisionStatusText(statusId) {
      switch (statusId) {
        case this.SurveyRevisionStatus.New:
          return this.$t('Webportal.Actions.SurveyRevision.StatusNew');
        case this.SurveyRevisionStatus.Approved:
          return this.$t('Webportal.Actions.SurveyRevision.StatusApproved');
        case this.SurveyRevisionStatus.Dismissed:
          return this.$t('Webportal.Actions.SurveyRevision.StatusDismissed');
        case this.SurveyRevisionStatus.AcceptedInProgress:
          return this.$t('Webportal.Actions.SurveyRevision.StatusAcceptedInProgress');
        case this.SurveyRevisionStatus.Solved:
          return this.$t('Webportal.Actions.SurveyRevision.StatusSolved');
        case this.SurveyRevisionStatus.Revised:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevised');
        case this.SurveyRevisionStatus.RevisedApproved:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedApproved');
        case this.SurveyRevisionStatus.RevisedDismissed:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedDismissed');
        case this.SurveyRevisionStatus.Done:
          return this.$t('Webportal.Actions.SurveyRevision.StatusDone');
      }
    },

    getRevisionStatusIcon(statusId) {
      switch (statusId) {
        case this.SurveyRevisionStatus.New:
          return "exclamation-circle";
        case this.SurveyRevisionStatus.Dismissed:
        case this.SurveyRevisionStatus.RevisedDismissed:
          return "times-circle";
        case this.SurveyRevisionStatus.AcceptedInProgress:
          return "play-circle";
        case this.SurveyRevisionStatus.Approved:
        case this.SurveyRevisionStatus.Solved:
        case this.SurveyRevisionStatus.Revised:
        case this.SurveyRevisionStatus.RevisedApproved:
          return "check-circle";
        case this.SurveyRevisionStatus.Done:
          return "dot-circle";
        }
    },

    isSurveyRevisionAllowed(surveyInstance) {
      return surveyInstance.IsVisibleForQuery;
    },

    getSurveyInstanceStatusText(statusId) {
      if (statusId == 220)
        return this.$t('Webportal.StatusOK');
      else if (statusId == 300)
        return this.$t('Webportal.StatusDeleted');
      else if (statusId <= 215)
        return this.$t('Webportal.StatusProcessing');
    }
  }
};
